export default __webpack_public_path__ + "static/media/refill_3.2515ce92.wav";